import React, { useEffect } from "react";
import classes from "./Solutions.module.scss";
import GradientButton from "../../ui/components/gradient-button/GradientButton.tsx";
import noise from "../../media/noise.png";
import { scroller } from "react-scroll";
import SubtitleTypeA from "../../ui/components/subtitle-type-a/SubtitleTypeA.tsx";
import Industries from "../software-development/industries/Industries.tsx";
import ListTypeB from "../../ui/components/list-type-b/ListTypeB.tsx";
import { IBlock } from "../../ui/components/list-type-a/ListTypeA.tsx";
import FormCard from "../../components/formCard/FormCard.tsx";
import { useTranslation } from "react-i18next";

const Solutions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  const scheduleConsultationHandler = () => {
    scroller.scrollTo("contact", {
      smooth: true,
      offset: -50,
      duration: 800,
    });
  };


  const listTypeBBlocks: IBlock[] = t('solutionsViewAll.listTypeBBlocks', {returnObjects: true})

  return (
    <main>
      <section
        className={`section--1 ${classes["heading-section"]}`}
        id="nav-dark"
      >
        <div className="circle circle--4"></div>
        <div className="circle circle--3"></div>
        <div className="circle circle--2"></div>
        <div className="circle circle--1"></div>
        <img src={noise} alt={"noise background"} className="noise" />

        <div className={classes.container}>
          <div className={classes.content}>
            <div className={classes.heading}>
              <h1>{t('solutionsViewAll.title')}</h1>
              <h1 className={classes.blue}>{t('solutionsViewAll.titleBlue')}</h1>
            </div>
            <div className={classes.actions}>
              <p className={classes.message}>{t('solutionsViewAll.text')}
              </p>
              <GradientButton
                text={t('solutionsViewAll.buttonText')}
                onClick={() => scheduleConsultationHandler()}
                className={classes.button}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section--white" id="nav-dark">
        <SubtitleTypeA
          title={t('solutionsViewAll.subtitleTypeA')}
          text={t('solutionsViewAll.subtitleTypeAText')}
        />
      </section>

      <Industries
        title={t('solutionsViewAll.industries')}
        subtitle={t('solutionsViewAll.industriesText')}
      />

      <section className="section--white" id="nav-dark">
        <ListTypeB title={t('solutionsViewAll.listTypeBBlocksTitle')} blocks={listTypeBBlocks} />
      </section>

      <section className="section--white" id="nav-dark">
        <FormCard />
      </section>
    </main>
  );
};

export default Solutions;
